// src/helpers/issuancePlanConfigLookup.ts
// Đọc file cấu hình top 5 kỳ phát hành gần nhất (public trên MinIO) — dùng cho LookupPortal thay vì
// gọi API IssuancePlan mỗi lần người dùng vào màn tra cứu, tránh nghẽn server khi có nhiều người
// tra cứu cùng lúc. File được ticket-service ghi đè mỗi khi có kỳ phát hành mới được tạo (xem
// CreateIssuancePlanCommand.cs), luôn chỉ chứa đúng 5 kỳ gần nhất theo CreatedAt.

import appConfig from 'config';
import { CacheService } from 'services/cache';
import { CacheConfig } from 'services/cache/CacheConfig';

export interface IssuancePlanConfigEntry {
  id: number;
  planCode: string;
  expectedDrawDate: string;
  status: number;
  numberRangeStart?: string | null;
  numberRangeEnd?: string | null;
  ticketSymbols: string[];
}

const CONFIG_OBJECT_KEY = 'IssuancePlan/issuance-plan-config.json';

// Cache theo cùng 1 key cho toàn hệ thống (không theo id vì đây là 1 file duy nhất) — check
// localStorage trước, chỉ fetch MinIO khi cache miss/hết TTL. Không cache lỗi/404 (file chưa được
// tạo lần nào, VD hệ thống chưa có kỳ phát hành nào) để lần check tiếp theo vẫn thử lại.
export const fetchTopRecentIssuancePlans = async (): Promise<IssuancePlanConfigEntry[]> => {
  const cacheKey = CacheConfig.ISSUANCE_PLAN_CONFIG.key;
  const cached = CacheService.get<IssuancePlanConfigEntry[]>(cacheKey);
  if (cached.cached && cached.data) return cached.data;

  const url = `${appConfig.minio.ENDPOINT}/${appConfig.minio.BUCKET_NAME}/${CONFIG_OBJECT_KEY}`;
  const response = await fetch(url);
  if (!response.ok) return [];

  const data: IssuancePlanConfigEntry[] = await response.json();
  CacheService.set(cacheKey, data, CacheConfig.ISSUANCE_PLAN_CONFIG.ttl);
  return data;
};
